export const shareBetHost: string = 'lvbet.lv/sports';
